import React, { useCallback, useEffect, useState } from 'react';
import { adminAPI } from '../services/api';

// Jugadores registrados. Como no hay servidor de correo, restablecer la
// contraseña desde aquí es el único camino de recuperación.
function AdminUsuarios({ onError }) {
  const [usuarios, setUsuarios] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [restableciendo, setRestableciendo] = useState(null);
  const [nuevaPassword, setNuevaPassword] = useState('');
  const [aviso, setAviso] = useState('');

  const cargar = useCallback(async () => {
    try {
      const respuesta = await adminAPI.usuarios();
      setUsuarios(respuesta.data);
    } catch (err) {
      onError(err, 'No se pudieron cargar los jugadores registrados');
    } finally {
      setCargando(false);
    }
  }, [onError]);

  useEffect(() => {
    cargar();
  }, [cargar]);

  const restablecer = async (usuario) => {
    try {
      await adminAPI.restablecerPassword(usuario.id, nuevaPassword);
      setAviso(`Contraseña cambiada para ${usuario.email}. Dísela por un canal privado.`);
      setRestableciendo(null);
      setNuevaPassword('');
    } catch (err) {
      onError(err, 'No se pudo restablecer la contraseña');
    }
  };

  const borrar = async (usuario) => {
    if (!window.confirm(
      `¿Borrar la cuenta de ${usuario.email}?\n\n` +
      'Las partidas que jugó se conservan, pero dejarán de estar enlazadas a su cuenta.'
    )) {
      return;
    }

    try {
      await adminAPI.borrarUsuario(usuario.id);
      setAviso(`Cuenta de ${usuario.email} borrada`);
      await cargar();
    } catch (err) {
      onError(err, 'No se pudo borrar la cuenta');
    }
  };

  const fecha = (valor) => (valor ? new Date(valor).toLocaleDateString('es-ES') : '—');

  if (cargando) {
    return <div className="card"><p>Cargando jugadores...</p></div>;
  }

  return (
    <div className="card">
      <h2 className="bloque-titulo">Jugadores registrados</h2>

      {aviso && <div className="success">{aviso}</div>}

      {usuarios.length === 0 ? (
        <p className="sin-datos">Todavía no se ha registrado nadie.</p>
      ) : (
        <div className="registro-lista">
          {usuarios.map(usuario => (
            <div key={usuario.id} className="registro-item">
              <div className="registro-principal">
                <span className="registro-codigo">{usuario.nombre}</span>
                <span className="registro-estado">hcp {usuario.handicap}</span>
              </div>
              <div className="registro-datos">
                {usuario.email} · {usuario.partidas} partidas · alta {fecha(usuario.created_at)}
              </div>

              {restableciendo === usuario.id ? (
                <div className="restablecer">
                  <input
                    type="text"
                    value={nuevaPassword}
                    onChange={e => setNuevaPassword(e.target.value)}
                    placeholder="Nueva contraseña (mínimo 8)"
                    autoComplete="off"
                  />
                  <div className="restablecer-botones">
                    <button
                      className="btn btn-primary"
                      onClick={() => restablecer(usuario)}
                      disabled={nuevaPassword.length < 8}
                    >
                      Guardar
                    </button>
                    <button
                      className="btn btn-secondary"
                      onClick={() => { setRestableciendo(null); setNuevaPassword(''); }}
                    >
                      Cancelar
                    </button>
                  </div>
                </div>
              ) : (
                <div className="usuario-acciones">
                  <button
                    className="registro-ver"
                    onClick={() => { setRestableciendo(usuario.id); setNuevaPassword(''); setAviso(''); }}
                  >
                    Restablecer contraseña
                  </button>
                  <button className="registro-ver peligro" onClick={() => borrar(usuario)}>
                    Borrar cuenta
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default AdminUsuarios;
